import clsx from "clsx";
import { FC, PropsWithChildren } from "react";

interface CotationCardProps extends PropsWithChildren {
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
}

const CotationCard: FC<CotationCardProps> = ({ className, children }) => {
  return (
    <div
      className={clsx([
        "flex rounded-xl border-2 border-gray-200 bg-white p-6 shadow-md",
        className,
      ])}
    >
      {children}
    </div>
  );
};

export default CotationCard;
